import { Action } from 'redux'
import { CalendarActions } from '../../../reducers/bookingCalendar/actionNames'

const fetchSelectedColumns = (): IFetchSelectedColumns => ({
  type: CalendarActions.FetchSelectedColumns,
})

const selectColumn = (index: Date): ISelectCalendarColumn => ({
  index,
  type: CalendarActions.SelectColumn,
})

const deleteSelectedColumns = (column: Date): IDeleteSelectedColumns => ({
  column,
  type: CalendarActions.DeleteSelectedColumns,
})

const addSelectedColumns = (column: Date): IAddSelectedColumns => ({
  column,
  type: CalendarActions.AddSelectedColumns,
})

const replaceSelectedColumns = (columns: Date[]): IReplaceSelectedColumns => ({
  columns,
  type: CalendarActions.ReplaceSelectedColumns,
})

export default selectColumn
export {
  fetchSelectedColumns,
  replaceSelectedColumns,
  deleteSelectedColumns,
  addSelectedColumns,
}
export type IFetchSelectedColumns = Action<CalendarActions.FetchSelectedColumns>

export interface ISelectCalendarColumn
  extends Action<CalendarActions.SelectColumn> {
  index: Date
}

export interface IDeleteSelectedColumns
  extends Action<CalendarActions.DeleteSelectedColumns> {
  column: Date
}

export interface IAddSelectedColumns
  extends Action<CalendarActions.AddSelectedColumns> {
  column: Date
}

export interface IReplaceSelectedColumns
  extends Action<CalendarActions.ReplaceSelectedColumns> {
  columns: Date[]
}
